<template>
  <div id="contenedor-titulo-tool-bar">
    <v-toolbar
      flat
      color="transparent">
      <div
        v-if="regresar"
        id="titulo-toolbar-btn-regresar">
        <v-tooltip
          top>
          <template
            v-slot:activator="{ on, attrs }">
            <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            @click="botonRegresar">
              <v-icon> mdi-chevron-left </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </div>
      <v-toolbar-title
        class="display-1"
        :class="{'ml-6': regresar}">
        {{ titulo }}
      </v-toolbar-title>
      <slot
        name="opciones">
      </slot>
      <v-spacer></v-spacer>
      <slot
        name="opciones-derecha">
      </slot>
    </v-toolbar>
    <div class="px-3">
      <slot name="end"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TituloToolBar',
  props: {
    titulo: {
      type: String,
      required: true,
    },
    regresar: {
      type: Boolean,
      required: false,
      default: false,
    },
    nombreRuta: {
      type: String,
      required: false,
    },
  },
  methods: {
    botonRegresar() {
      const { regresar, nombreRuta } = this;

      if (regresar && nombreRuta) {
        this.$router.push({ name: nombreRuta });
      } else {
        this.$router.back();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#titulo-toolbar-btn-regresar {
  position: absolute;
  left: -10px;
  right: 0;
  margin: auto
}
</style>
